var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z","clipRule":"evenodd"}));
}

Plus.defaultProps = {"viewBox":"0 0 20 20","fill":"currentColor"};

module.exports = Plus;

Plus.default = Plus;
